module.exports = __webpack_public_path__ + "static/media/game(8).1e2fd9f1.PNG";